// Password Toggle

const pwToggle = '<div id="js-pw-toggle" class="toggle-password"><i class="far fa-eye toggle-icon"></i> <span class="toggle-label">Show</span></div>'

$('input[type=password]').each(function (i, e) {
  $(this).after(pwToggle)
})

$('body').on('click', '#js-pw-toggle', function () {
  const $fields = $(this).parent().find('.tn-password, .tn-current-password, .tn-new-password, .tn-confirm-password');

  const type = $fields.first().attr('type'); // Check the type of the first field
  const label = $(this).find('.toggle-label');
  const icon = $(this).find('.toggle-icon');

  if (type === 'text') {
    $fields.attr('type', 'password');
    $(label).text('Show');
    $(icon).toggleClass('fa-eye fa-eye-slash');
  } else {
    $fields.attr('type', 'text');
    $(label).text('Hide');
    $(icon).toggleClass('fa-eye fa-eye-slash');
  }
});


